import React from 'react';
import styled from '@nykaa/ui-components/styles/styled';
import RatingSvg from './RatingSvg';
import EmptyStarIcon from './EmptyStar';
const Rating = styled.div `
  line-height: 12px;
  margin-top: 5px;
  .star-wrap {
    display: inline-block;
    margin-right: 2px;
  }
`;
const Count = styled.span `
  ${({ theme }) => theme.typography.type120};
  line-height: 12px;
  color: ${({ theme }) => theme.colors.state};
  margin-left: 4px;
`;
const RatingInfo = ({ rating, ratingCount, }) => {
    const fullStars = Math.round(rating);
    return ((ratingCount > 0) && (React.createElement(Rating, null,
        [...Array(5)].map((star, index) => {
            const starKey = `${index}-${star}`;
            const emptyStar = (index) >= fullStars;
            return (React.createElement("span", { key: starKey, className: "star-wrap" }, (emptyStar) ? React.createElement(EmptyStarIcon, null) : React.createElement(RatingSvg, null)));
        }),
        React.createElement(Count, null, ratingCount))));
};
export default RatingInfo;
